import {
  ArrowLeftIcon,
  FeedIcon,
  ListIcon,
  QuestionIcon,
  SmileIcon,
  TrophyIcon,
} from "@sidelinesports/icons";
import type { FC } from "react";
import type { ApiGameDetails } from "../../../../api/games.ts";
import { Dialog, SlideoutMenu } from "../../../../components/index.tsx";
import { useNavigateTo } from "../../../../hooks/use-navigate-to.ts";
import { GameHistoryDialog } from "../../../GameHistoryDialog/GameHistoryDialog.tsx";
import { GameWelcomeMessageDialog } from "../../../GameWelcomeDialog/GameWelcomeMessageDialog.tsx";
import { ScoreLegend } from "../../../PickYourPlayers/components/index.tsx";
import { LeaderboardDialog } from "../Leaderboard/LeaderboardDialog.tsx";
import { MenuTriggerButton } from "./MenuTriggerButton.tsx";

export const Menu = ({ game }: { game: ApiGameDetails }) => {
  return (
    <SlideoutMenu.Root>
      <SlideoutMenu.Trigger as={MenuTriggerButton} />
      <SlideoutMenu.Content name="Game menu">
        <div role="menu" aria-label="Game menu">
          <WelcomeMessage game={game} />
          <ScoreLegendItem game={game} />
          <GameLeaderboard />
          <HowToPlay hidden />
          <GameHistory />
          <SlideoutMenu.Divider />
          <BackToGames />
        </div>
      </SlideoutMenu.Content>
    </SlideoutMenu.Root>
  );
};

const WelcomeMessage: FC<{
  game: ApiGameDetails;
}> = (props) => {
  const hasWelcomeMessage = props.game.prizes.length > 0;

  if (!hasWelcomeMessage) {
    return null;
  }

  return (
    <Dialog.Root>
      <Dialog.Trigger
        as={SlideoutMenu.MenuItem}
        icon={<SmileIcon />}
        name="Welcome Message"
        {...props}
      >
        Welcome Message
      </Dialog.Trigger>
      <GameWelcomeMessageDialog name="GameWelcomeMessageDialog" />
    </Dialog.Root>
  );
};

const ScoreLegendItem: FC<{ game: ApiGameDetails }> = (props) => (
  <ScoreLegend
    game={props.game}
    trigger={
      <Dialog.Trigger
        as={SlideoutMenu.MenuItem}
        icon={<ListIcon />}
        name="Score Legend"
        {...props}
      >
        Score Legend
      </Dialog.Trigger>
    }
  />
);

const GameLeaderboard: FC = (props) => (
  <Dialog.Root>
    <Dialog.Trigger
      as={SlideoutMenu.MenuItem}
      icon={<TrophyIcon />}
      name="Game Leaderboard"
      {...props}
    >
      Game Leaderboard
    </Dialog.Trigger>
    <LeaderboardDialog />
  </Dialog.Root>
);

const HowToPlay: FC<{ hidden?: boolean }> = (props) =>
  props.hidden ? null : (
    <SlideoutMenu.MenuItem
      icon={<QuestionIcon />}
      name="How to Play"
      {...props}
    >
      How to Play
    </SlideoutMenu.MenuItem>
  );

const GameHistory: FC = (props) => (
  <Dialog.Root>
    <Dialog.Trigger
      as={SlideoutMenu.MenuItem}
      icon={<FeedIcon />}
      name="Game History"
      {...props}
    >
      Game History
    </Dialog.Trigger>
    <GameHistoryDialog name="GameHistoryDialog" />
  </Dialog.Root>
);

const BackToGames: FC = (props) => (
  <SlideoutMenu.MenuItem
    onClick={useNavigateTo("/games")}
    icon={<ArrowLeftIcon />}
    name="Back to Games"
    {...props}
  >
    Back to Games
  </SlideoutMenu.MenuItem>
);
